import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentLanguageService } from '@shared/services/language';
import { MiddleOfficeService } from '@shared/services/middle-office';
import { PlatformContextService } from '@shared/services/platform-context';
import { map } from 'rxjs';

export const middleOfficeGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const platformContext = inject(PlatformContextService);
  const middleOfficeService = inject(MiddleOfficeService);
  const token = route.queryParamMap.get('token');
  const home = router.createUrlTree([inject(CurrentLanguageService).language.urlPrefix ?? '/']);

  // A transition from Osiris, which only makes sense where the browser reads the CMS live: the static site,
  // reading the prefetch JSONs, goes home without calling userinfos.
  if (!platformContext.readsDrupal() || !token) {
    return home;
  }

  return middleOfficeService.resolveStoreUrl(token).pipe(map((url) => (url ? router.createUrlTree([url]) : home)));
};
